// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"ScrollView_scrollable__qjmw9","justifyCenter":"ScrollView_justifyCenter__m2hLb"};